import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.reset = this.reset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof this.props.onError === 'function') {
      try { this.props.onError(error, info); } catch (_) {}
    }
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== 'production') console.error('ErrorBoundary', error, info);
  }

  componentDidUpdate(prevProps) {
    const a = this.props.resetKeys || [];
    const b = prevProps.resetKeys || [];
    const changed = a.length !== b.length || a.some((v, i) => v !== b[i]);
    if (changed && this.state.hasError) {
      this.setState({ hasError: false, error: null });
    }
  }

  reset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return typeof this.props.fallback === 'function'
          ? this.props.fallback({ error: this.state.error, reset: this.reset })
          : this.props.fallback;
      }

      return (
        <div style={{ padding: 24, fontFamily: 'Inter, sans-serif' }}>
          <h2 style={{ marginTop: 0 }}>Something went wrong.</h2>
          {process.env.NODE_ENV !== 'production' && (
            <pre style={{ whiteSpace: 'pre-wrap', background: '#0f172a', color: '#e2e8f0', padding: 12, borderRadius: 8 }}>
              {String(this.state.error)}
            </pre>
          )}
          <button onClick={this.reset} style={{ marginTop: 8 }}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;


